export default __webpack_public_path__ + "static/media/md-card-bg-data-analysis.85a7ff04.png";